export default __webpack_public_path__ + "static/BrandonGrotesque-BoldItalic-c04bf6eb42ec412786f4224288f23f8b.woff2";